//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ErrorDisplay from "../../../common/ErrorDisplay.vue";
import CouponInput from "../CouponInput.vue";
import MemberEmail from "../profile/form/MemberEmail.vue";
import MemberPassword from "../profile/form/MemberPassword.vue";
import DefaultTeamSignupStrategy from "./strategy/defaultTeamSignupStrategy";
import DefaultSignupStrategy from "./strategy/defaultSignupStrategy";
import BrooksSignupStrategy from "./strategy/brooksSignupStrategy";
import MidstateMassiveSignupStrategy from "./strategy/midstateMassiveSignupStrategy";
import SuuntoSignupStrategy from "./strategy/suuntoSignupStrategy";
import { mapGetters } from 'vuex';

export default {
  name: "Signup",
  components: {
    MemberPassword,
    MemberEmail,
    CouponInput,
    ErrorDisplay,
  },
  created() {
    this.teamId = this.$route.params.teamId || null;
    if (this.teamId) {
      this.strategy = new DefaultTeamSignupStrategy();
      return;
    }
    this.coupon = this.$route.params.couponCode || null;
    if (this.coupon) {
      if (this.strategies[this.coupon]) {
        this.strategy = new this.strategies[this.coupon]();
      } else {
        this.showCoupon = true;
        this.disableCoupon = true;
      }
    }

    if (this.strategy === null) {
      this.strategy = new DefaultSignupStrategy();
    }
  },
  data() {
    return {
      email: null,
      password: "",
      loading: false,
      error: null,
      formIsValid: null,
      showCoupon: true,
      disableCoupon: false,
      coupon: null,
      teamId: null,
      strategy: null,
      strategies: {
        brooks2019_s3: BrooksSignupStrategy,
        midstatemassive_2019: MidstateMassiveSignupStrategy,
        suuntofreetrial: SuuntoSignupStrategy,
      },
    };
  },
  computed: {
    ...mapGetters([
      'loggedInMember',
    ]),
  },
  methods: {
    async signup() {
      this.loading = true;
      this.error = null;
      try {
        const result = await this.$store.dispatch("register", {
          email: this.email,
          password: this.password,
          coupon: this.coupon,
        });

        if (this.teamId) {
          const member = await this.$container.dao.addMemberToTeam(
            result.member.member_id,
            this.teamId
          );
          await this.$container.memberService.updateMember(member.data, false);
        }
        await this.$store.dispatch("loadData");
        this.$container.analytics.trackRegistration(
          this.$store.state.user.memberId
        );

        if (this.platform() === 'ios') {
          window.webkit.messageHandlers.callbackHandler.postMessage(JSON.stringify({
            type: 'setMemberId',
            memberId: this.loggedInMember.memberId,
            sub: this.loggedInMember.awsCognitoSub,
          }));
        }

        this.$router.push({ name: "setup" });
      } catch (error) {
        this.handleSignupError(error);
      } finally {
        this.loading = false;
      }
    },
    handleSignupError(error) {
      if (error.response && error.response.data) {
        this.error = error.response.data;
        if (this.error.indexOf('email already exists') > -1) {
          this.error += ' Click <a href="/login">here</a> to log in.';
        }
      } else {
        this.error = error;
      }
      this.loading = false;
    },
  },
};
